// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3bHcS","list":"PatternAutocomplete_list__pDNzy"};